(() => {
  const hosts = new WeakSet();
  const roots = new WeakSet();
  const inputSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;

  function syncName(root, field, targetId = `shipping_address_${field}`) {
    const source = root.querySelector(`#${field}`);
    const target = root.querySelector(`#${targetId}`);
    if (!source || !target || source.value === target.value) return;
    inputSetter.call(target, source.value);
    target.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
    target.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }

  function prepare(root) {
    const promptTemplate = document.querySelector('[data-ora-trade-prompt]');
    const formHeading = root.querySelector('h2');
    const description = formHeading?.nextElementSibling;
    if (promptTemplate && root.querySelector('#first_name') && description?.tagName === 'DIV' && !description.querySelector('[data-ora-trade-login-prompt]')) {
      description.replaceChildren(promptTemplate.content.cloneNode(true));
    }
    if (!root.querySelector('[data-ora-trade-styles]')) {
      const style = document.createElement('style');
      style.dataset.oraTradeStyles = '';
      style.textContent = `
        :host {
          --form-field-border-radius: 0px;
          --button-border-radius: 0px;
          --forms-base-font-size: 13px;
          --forms-body-font: normal 400 13px Source Sans Pro, sans-serif;
        }
        [data-ora-trade-login-prompt] { margin: 0; }
        .ora-trade-sign-in__link { color: inherit; text-decoration: underline; text-underline-offset: 3px; }
        input, select, textarea, button { border-radius: 0 !important; }
        h2 {
          font-family: var(--ora-trade-heading-font-family, 'freight-neo-pro', sans-serif) !important;
          font-weight: var(--heading-font-weight, 400) !important;
          font-style: var(--heading-font-style, normal) !important;
          font-size: var(--text-h2, 1.5rem) !important;
          letter-spacing: var(--heading-letter-spacing, 0.02em) !important;
          text-transform: var(--heading-text-transform, normal) !important;
        }
        [data-ora-trade-name-row], [data-ora-trade-duplicate-company] { display: none !important; }
      `;
      root.append(style);
    }
    const first = root.querySelector('#shipping_address_first_name');
    const last = root.querySelector('#shipping_address_last_name');
    if (first && last) {
      const row = first.parentElement?.parentElement?.parentElement;
      if (row?.contains(last)) row.dataset.oraTradeNameRow = '';
    }
    const recipient = root.querySelector('#shipping_address_recipient');
    if (recipient) recipient.parentElement.dataset.oraTradeDuplicateCompany = '';
    if (!roots.has(root)) {
      roots.add(root);
      root.addEventListener('input', event => {
        const id = event.target.id;
        if (id === 'first_name' || id === 'last_name') syncName(root, id);
        if (id === 'company_name') syncName(root, id, 'shipping_address_recipient');
      });
      root.addEventListener('change', event => {
        const id = event.target.id;
        if (id === 'first_name' || id === 'last_name') syncName(root, id);
        if (id === 'company_name') syncName(root, id, 'shipping_address_recipient');
      });
      root.addEventListener('submit', () => {
        syncName(root, 'first_name');
        syncName(root, 'last_name');
        syncName(root, 'company_name', 'shipping_address_recipient');
      }, true);
      new MutationObserver(() => prepare(root)).observe(root, { childList: true, subtree: true });
    }
    syncName(root, 'first_name');
    syncName(root, 'last_name');
    syncName(root, 'company_name', 'shipping_address_recipient');
  }

  function discover() {
    document.querySelectorAll('[data-forms-id="forms-root-1197793"] shopify-forms-embed').forEach(host => {
      const heading = document.querySelector('main .h2');
      if (heading) host.style.setProperty('--ora-trade-heading-font-family', getComputedStyle(heading).fontFamily);
      host.style.setProperty('--form-field-border-radius', '0px');
      host.style.setProperty('--button-border-radius', '0px');
      if (host.shadowRoot) prepare(host.shadowRoot);
      if (!hosts.has(host)) {
        hosts.add(host);
        customElements.whenDefined('shopify-forms-embed').then(() => {
          if (host.shadowRoot) prepare(host.shadowRoot);
        });
      }
    });
  }

  discover();
  new MutationObserver(discover).observe(document.documentElement, { childList: true, subtree: true });
})();
